// extracted by mini-css-extract-plugin
export var editButton = "detailsGalerie-module--edit-button--46792";
export var galerieContainer = "detailsGalerie-module--galerie-container--46666";
export var galerieImage = "detailsGalerie-module--galerie-image--21988";
export var galerieTitle = "detailsGalerie-module--galerie-title--78111";
export var masonryGrid = "detailsGalerie-module--masonry-grid--96dd4";
export var masonryGridColumn = "detailsGalerie-module--masonry-grid-column--5fa6d";